var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldPersonalcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3C3.79 3 2 4.78 2 6.97v10.06C2 19.22 3.79 21 6 21h12c2.21 0 4-1.78 4-3.97V6.97C22 4.78 20.21 3 18 3H6zm4.81 6.48c0 1.27-1.04 2.31-2.31 2.31s-2.31-1.04-2.31-2.31S7.23 7.17 8.5 7.17s2.31 1.04 2.31 2.31zM12 16.82H5c-.14 0-.28-.06-.37-.16a.52.52 0 0 1-.13-.38 3.548 3.548 0 0 1 3.19-3.17 8.66 8.66 0 0 1 1.61 0c1.68.16 3.03 1.49 3.19 3.17.02.14-.03.28-.12.38-.09.1-.23.16-.37.16zm5-.07c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.34.75-.75.75h-2zm-2-4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4zm-1-4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75h-5z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldPersonalcard);
export default __webpack_public_path__ + "static/media/vuesax-bold-personalcard.cadeff5adf0fa0ac3aab0118f3df1650.svg";
export { ForwardRef as ReactComponent };